<div class="container pt-3">
  <rbb-side-menu-headline description="Editor zum erstellen von neuen Formularen." headline="Editor" icon="fas fa-pencil-ruler"/>

  @if (employee && employee.creator) {
    <div class="row mb-4">
      <div class="col">
        <a class="btn btn-sm btn-primary fw-bold" routerLink="/editor/new">Neues Formular erstellen</a>
      </div>
    </div>
  }

  @if (!forms) {
    <div class="text-center m-auto mt-5">
      <rbb-loader/>
      <small class="text-secondary d-block">Formulare werden geladen...</small>
    </div>
  }

  @if (forms && transferSystems.length) {
    <div class="row">
      <div class="col">
        <span class="small text-secondary d-block mb-3 description-badge"><i class="fas fa-info"></i>&ensp;Wenn ein fertiges Formular ins Prodsystem übertragen werden soll, kontaktieren Sie bitte <a href="mailto:mit-dev.admin@rbb-online.de">mit-dev.admin&#64;rbb-online.de</a></span>
      </div>
    </div>
  }

  @if (forms && columns) {
    <rbb-table [responsiveBreakpoint]="'lg'" [columns]="columns" [values]="forms" [sort]="true" [altValueMapper]="altValueMapper" [pageSizes]="[20]" [search]="true" searchType="SEPARATE" [tableData]="tableData"/>
    <ng-template let-column="column" let-value="value" #tableData>
      @switch (column.field) {
        @case ('name') {
          <td>
            <span class="fw-bold">
              {{value[column.field]}}&ensp;
              @if (isProductive(value)) {
                <span class="badge bg-primary"><small>PROD</small></span>
              }
            </span>
          </td>
        }
        @case ('createdByLastName') {
          <td>
            {{value.createdByFirstName}} {{value.createdByLastName}}
          </td>
        }
        @case ('timestamp') {
          <td>
            <span class="small">{{ value[column.field] | date:'dd.MM.y HH:mm'}}</span>
          </td>
        }
        @case ('visible') {
          <td class="text-left">
            @if (value[column.field]) {
              <span class="text-success"><i class="far fa-eye"></i></span>
            } @else {
              <span class="text-danger"><i class="far fa-eye-slash"></i></span>
            }
          </td>
        }
        @case ('approvalDataProtectionOfficer') {
          <td>
            @switch (value[column.field]) {
              @case ('APPROVED') {
                <span class="text-success">Ok</span>
              }
              @case ('DECLINED') {
                <span class="text-danger">Abgelehnt</span>
              }
              @case ('PENDING') {
                <span class="text-secondary">Warte auf Freigabe</span>
              }
            }
          </td>
        }
        @case ('edit') {
          <td class="td-icon">
            <a routerLink="/editor/{{value.id}}"><i class="fas fa-edit d-inline-block pointer transform grow-effect text-secondary" data-toggle="tooltip" data-placement="top" aria-hidden="true" title="Bearbeiten"></i></a>
          </td>
        }
        @case ('history') {
          <td class="td-icon">
            <a routerLink="/editor/{{value.id}}/history"><i class="far fa-clock d-inline-block pointer transform grow-effect text-secondary" data-toggle="tooltip" data-placement="top" aria-hidden="true" title="Verlauf"></i></a>
          </td>
        }
        @case ('delete') {
          <td class="td-icon">
            <i class="fas fa-times d-inline-block pointer transform grow-effect text-danger" data-toggle="tooltip" data-placement="top" aria-hidden="true" title="Löschen" (click)="openModal(value.id)"></i>
          </td>
        }
        @default {
          <td>{{ value[column.field] }}</td>
        }
      }
    </ng-template>
  }
</div>


<ng-template #ngModal>
  <div class="modal-header pb-2 pt-2">
    <h5 class="modal-title">
      <span>Formular löschen</span>
    </h5>
  </div>
  <div class="modal-body p-3">
    <div class="row">
      <div class="col-12">
        <p>Wollen Sie das Formular wirklich unwiderruflich löschen?</p>
      </div>
    </div>
  </div>
  <div class="modal-footer pb-2 pt-2">
    <button (click)="deleteForm()" class="btn btn-danger btn-sm"><i class="fas fa-trash-alt" aria-hidden="true"></i>&ensp;Löschen</button>
    <button (click)="closeModal()" class="btn btn-secondary btn-sm" type="button"><i class="fas fa-times" aria-hidden="true"></i>&ensp;Schließen</button>
  </div>
</ng-template>

